


<template>
  <div id="reporte_fuera" >
    <div>
      <v-breadcrumbs :items="breadcrumbs" >
        <v-icon slot="divider" >forward</v-icon>
      </v-breadcrumbs>
    </div>
  
    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-col xs="12" >
          <base-material-card color="primary" icon="library_books" title="INFORMES PRESENTADOS FUERA DE PLAZO" class="elevation-1 px-5 py-3" >
  
                <div class="contenedor-tab-reportes" >
  
                  <v-card-text>
                    <v-card-title>
                      <span class="headline" ></span>
                    </v-card-title>
                    <v-form ref="form" lazy-validation>
                      <v-row row wrap>
                          <v-col cols="12" sm="3" md="3" lg="3" >
                            <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                              <template v-slot:activator="{ on }" >
                                <v-text-field clearable v-on="on" v-model="model.fecha_de" label="Fecha De" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                    :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                              </template>
  
                              <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                                <v-spacer />
  
                                <v-btn color="secondary" x-small @click="menu1 = false" >
                                  Cancelar
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" >
                            <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                              <template v-slot:activator="{ on }" >
                                <v-text-field clearable v-on="on" v-model="model.fecha_a" label="Fecha A" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                    :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                              </template>
  
                              <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                                <v-spacer />
  
                                <v-btn color="secondary" x-small @click="menu2 = false" >
                                  Cancelar
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col>
                              <v-btn small color="info" @click="cargar_consulta();" >Consultar</v-btn>
                              <v-btn v-if="datos.length > 0" color="green" @click="exportar('xlsx')" small>
                                <v-icon>mdi-file</v-icon>Excel
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-form>
              
                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-1 pa-2" >
                      <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                      </template>
  
                      <template slot="ejercicio" slot-scope="props">
                        <div style="text-align:center"><v-chip small :color="props.row.conteo_descargos>0?'warning':'error'">{{ props.row.ejercicio}}</v-chip></div>
                      </template>
  
                      <template slot="periodo" slot-scope="props">
                        <div style="text-align:center"><v-chip small :color="props.row.conteo_descargos>0?'warning':'error'">{{ props.row.periodo}}</v-chip></div>
                      </template>
                      <template slot="valor_comercial_calculado" slot-scope="props">
                                      <div class="text-number">
                                          {{formatNumber(props.row.valor_comercial_calculado, 2)}}
                                      </div>
                       </template>
                       
                      <template slot="clave" slot-scope="props">
                        <div style="text-align:center">{{ props.row.clave}}</div>
                      </template>
                     
  
                      <template slot="conteo_pedimentos" slot-scope="props">
                        <div style="text-align:center">{{ props.row.conteo_pedimentos}}</div>
                      </template>
  
                      <template slot="conteo_descargos" slot-scope="props">
                        <div style="text-align:center">{{ props.row.conteo_descargos}}</div>
                      </template>
  
                      <template slot="folio" slot-scope="props">
                        <div style="text-align:center"><a @click="dialog_consolidado=true;" title="Ver Secuencias del Informe" v-tippy>{{ props.row.folio}}</a></div>
                      </template>
                      <template slot="folio" slot-scope="props">
                                    <div >
                                        {{props.row.folio}}<v-icon small  color="blue" @click="open_secuencias(props.row.folio)" title="Ver Secuencias del Informe" v-tippy>mdi-table</v-icon>
                                        
                                    </div>
                       </template>
                      <template slot="fecha_recepcion" slot-scope="props">
                        <div style="text-align:center">{{ parseDate(props.row.fecha_recepcion)}}</div>
                      </template>
                      <template slot="fecha_validacion" slot-scope="props">
                        <div style="text-align:center">{{ parseDate(props.row.fecha_validacion)}}</div>
                      </template>
                      <template slot="fecha_aplicacion" slot-scope="props">
                        <div style="text-align:center">{{ parseDate(props.row.fecha_aplicacion)}}</div>
                      </template>
                      <template slot="pedimentos_faltantes" slot-scope="props">
                        <div style="text-align:center" @click="row_selected=props.row; abrir_faltantes(props.row.pedimentos_faltantes)"><v-btn x-small color="red" title="Ver Pedimentos Faltantes" v-tippy>{{ props.row.pedimentos_faltantes.length }}</v-btn></div>
                      </template>
  
  
                    </v-client-table>
                  </v-card-text>
                </div>
  
          </base-material-card>
        </v-col>
      </v-row>
      <LoaderFraces ref="estadoLoader" :mensajes="lista_mensajes" ></LoaderFraces>
      <v-dialog v-model="dialog_consolidado" width="90%">
                    <v-card>
                        <v-card class="primary white--text titulomodal" >
                                        <v-icon @click.native="dialog_consolidado = false" class="white--text" >close</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Secuencia de Informes de Descargo</strong>
                                        </span>
                                    </v-card>

                <v-card-text>
                <p/>
                    <v-client-table ref="vuetable3" :data="secuencias" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>
                               
                                <template slot="valor_comercial_calculado" slot-scope="props">
                                    <div class="text-number">
                                        {{formatNumber(props.row.valor_comercial_calculado, 2)}}
                                    </div>
                                </template>

                            </v-client-table>
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog_consolidado = false">
                                CANCELAR
                            </v-btn>

                        </v-card-actions>
                        </v-card>
                </v-dialog>
      <v-dialog v-model="modal_faltantes" max-width="70%" >
        <v-card>
        
         
              <a   @click="modal_faltantes=false" small style="float: right;">
                                <v-icon large>mdi-close</v-icon>
                              </a>
                              <v-card-title style="margin-top:-50px">
  
  <h3 color="primary"><b>PEDIMENTOS OMITIDOS</b></h3>
  <h4> CLAVE: <b>{{ row_selected.clave }}</b>  &nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  AÑO:<b>{{ row_selected.ejercicio }}</b> &nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;     PERIODO:<b> {{ row_selected.periodo }}</b>     </h4>
  
  </v-card-title>
  
          <v-card-text>
          
        
          
            <v-client-table ref="vuetable_faltantes" :data="data_faltantes" :columns="columns_faltantes" :options="options_faltantes" class="elevation-2 pa-2">
              <template slot="noResults">
                <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
              </template>
              <template slot="fecha_operacion" slot-scope="props">
                <div v-if="props.row.fecha_operacion != null">
                  {{ props.row.fecha_operacion.substring(0,10) }}
                </div>
                <div v-else>
                  {{props.row.fecha_operacion}}
                </div>
              </template>
            </v-client-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  </template>
  
  <script>
  import axios from "axios";
  import moment from "moment";
  import Vue from "vue";
  import LoaderFraces from "@/components/LoaderFraces";
  import XLSX from 'xlsx';
  
  export default {
    components: {
      LoaderFraces,
    },
    created: function() {
      
        var f_a = new Date();
  
        let y = f_a.getFullYear();
        let m = f_a.getMonth() + 1;
        let d = f_a.getDate();
  
       
        if (m < 10)
            m = '0' + m;
        if (d < 10)
            d = '0' + d;
  
        let fecha = y + "-" + m + "-" + d;
        this.model.fecha_a = fecha;
        this.model.fecha_de = y + "-01-01";
  
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
          this.permisoEliminar = true;
        }
        this.loading = false;
        this.model.rfc = this.$local_storage.get("rfc");
        this.model.usuario = this.$local_storage.get("id_usuario");
        
    },
    mounted: function(){
      
      this.getPeriodos();
    },
    computed: {
          datafiltered() {
  
              let result = [];
              if (this.$refs.vuetable != null) {
                 result = this.$refs.vuetable.allFilteredData;
                  return result;
              } else {
                 result = this.datos;
                  return result;
              }
      },
    },
    data: () => ({
      dialog_consolidado: false,
      row_selected: [],
      lista_mensajes: [
              "AGRADECEMOS SU PACIENCIA..",
              "ESTAMOS PROCESANDO LOS CARGOS..",
              "VERIFICANDO IDENTIFICADORES..",
              "VALIDACIÓN DE FORMAS DE PAGO..",
              "PROCESANDO ABONOS A LA FECHA..",
              "VERIFICANDO FRACCIONES..",
              "VALIDANDO CUENTAS POR IDENTIFICADOR DE ACTIVO..",
              "ANALIZANDO SOBREDESCARGO..",
              "GESTIONANDO SALDOS POR FRACCIÓN..",
              "TOTALIZANDO VALOR COMERCIAL PENDIENTE DE RETORNO..",
              "TOTALIZANDO CRÉDITO FISCAL.."
          ],
      cliente:"",
      modal_faltantes: false,
      permisoEliminar:false,
      fab: false,
      rfc: '',
      tipo: '',
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/home"
        },
        {
          text: "Auditorías",
          disabled: true,
          to: ""
        },
        {
          text: "Hallazgos en Informes",
          disabled: true,
          to: ""
        },
        {
          text: "Fuera de Plazo",
          disabled: true,
          to: ""
        }
      ],
      datos: [],
      secuencias: [],  
      columns: [ 
                   'folio', 'cabecera.consecutivo',
                  'cabecera.destino_aduanero', 'cabecera.ejercicio', 'cabecera.periodo_asociado', 
                  'fecha_recepcion', 'fecha_validacion', 'fecha_aplicacion', 'estatus_validacion',
                    'valor_comercial_calculado', 'estatus'
              ],
        options: {
                  filterable: ['folio',
                      'cabecera.destino_aduanero', 'cabecera.ejercicio', 'cabecera.periodo_asociado', 'cabecera.consecutivo',
                      'fecha_recepcion', 'fecha_validacion', 'fecha_aplicacion', 'estatus_validacion',
                       'valor_comercial_calculado',  'estatus'
                  ],
                  sortable: ['folio',
                      'cabecera.destino_aduanero', 'cabecera.ejercicio', 'cabecera.periodo_asociado', 'cabecera.consecutivo',
                      'fecha_recepcion', 'fecha_validacion', 'fecha_aplicacion', 'estatus_validacion',
                       'valor_comercial_calculado',  'estatus'
                  ],
                  listColumns: {
                      
                      estatus: [
                        {
                          id:"",
                          text:"Todos",
                          default:true
                        },{
                              id: 'Aplicado',
                              text: "Aplicado"
                          },
                          {
                              id: "Reemplazado",
                              text: "Reemplazado"
                          },
                          {
                              id: "Faltante",
                              text: "Faltante"
                          },
                          {
                              id: "No Válido",
                              text: "No Válido"
                          },
                      ]
                  },
                  headings: {
                     
                      'folio': 'Folio SAT',
                      'cabecera.destino_aduanero': 'Destino Aduanero',
                      'cabecera.ejercicio': 'Ejercicio',
                      'cabecera.periodo_asociado': 'Periodo Afectado',
                      'cabecera.consecutivo': 'No. Movimiento',
                      'fecha_recepcion': 'Fecha Recepción',
                      'fecha_validacion': 'Fecha Validación',
                      'fecha_aplicacion': 'Fecha Aplicación',
                      'estatus_validacion': 'Estatus de Validación',
                      'valor_comercial_calculado': 'Valor Comercial',
                      'valor_comercial_final': 'Valor Comercial del Descargo',
                      'estatus': 'Estatus General'
                  }
              },
              excel: {
                  'Fecha Proceso SA31':'fecha' ,
                  'Folio SAT':  'folio' ,
                  'Planta-Referencia': 'planta',
                  'Destino Aduanero' : 'cabecera.destino_aduanero' ,
                  'Ejercicio':  'cabecera.ejercicio',
                  'Periodo Afectado':  'cabecera.periodo_asociado' ,
                  'No. Movimiento':   'cabecera.consecutivo' ,
                  'Fecha Recepción':   'fecha_recepcion',
                  'Fecha Validación':  'fecha_validacion' ,
                  'Estatus de Validación':  'estatus_validacion' ,
                  'Estatus de Aplicación':   'estatus_aplicacion' ,
                  'Fecha Aplicación':   'fecha_aplicacion' ,
                  'Valor Comercial':   'valor_comercial_calculado' ,
                  'Valor Comercial del Descargo' : 'valor_comercial_final' ,
                  'Estatus': 'estatus'
                  },
      loading: false,
      show_loading: true,
      periodos:[],
      model: {
        rfc: "",
        usuario: "",
        fecha_de: "",
        fecha_a: "",
      },
  
      selecciona_todo8: false,
      selecciona_todo8_partida: false,
      rules: {
        required: v => !!v || "Este campo es requerido",
        numeric: value => {
          const pattern = /^[\d]*$/;
          return pattern.test(value) || "Solo se permiten números";
        }
      },
      menu1: false,
      menu2: false,
      data_faltantes:[],
      columns_faltantes: [ 'no_pedimento', 'fecha_operacion'],
      options_faltantes: {
        headings: {
          
          no_pedimento: "No Pedimento",
          fecha_operacion: "Fecha Operación"
        }
      }
    }),
    methods: {
      abrir_faltantes: function(datos) {
        this.modal_faltantes = true;
        this.data_faltantes = datos;
      },
      getPeriodos: function () {
  
        axios.post(this.$hostname + "apendices/lista/", {
                'tabla': 32
            })
            .then(response => {
  
                this.periodos = response.data;
                this.cargar_consulta();
  
            })
            .catch(error => {
  
            });
      },
      open_secuencias(folio){
       

        let self = this;
         

          folio = folio.substring(0,22);

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc = this.$local_storage.get("rfc");
            this.selecteds = [];
            axios.post(this.$apiSA31 + "soluciona31/list_informes_descargo/", {
                    'rfc': rfc,
                   'campos':{'fecha':1, 'folio':1, 'cabecera':1, 'fecha_recepcion':1, 'fecha_validacion':1, 'estatus_validacion':1,
                    'fecha_aplicacion':1, 'estatus_aplicacion':1, 'valor_comercial_final':1, 'valor_comercial_calculado':1,
                    'error':1, 'estatus':1, 'key':1 , 'planta':1, 'validado':1
                     },
                     filtros: { 'folio': {
                                      "$regex": folio,
                                      "$options": 'i'
                                    }},
                })
                .then(response => {
                    this.secuencias = response.data;
                   
                    for (var k in this.secuencias) {
                      
                        this.secuencias[k].fecha = moment(String(this.secuencias[k].fecha)).format("YYYY-MM-DD");

                        this.secuencias[k].fecha_recepcion = moment(String(this.secuencias[k].fecha_recepcion)).format("YYYY-MM-DD");
                        if (this.secuencias[k].fecha_recepcion == 'Invalid date') this.secuencias[k].fecha_recepcion = ' ';

                        this.secuencias[k].fecha_validacion = moment(String(this.secuencias[k].fecha_validacion)).format("YYYY-MM-DD");
                        if (this.secuencias[k].fecha_validacion == 'Invalid date') this.secuencias[k].fecha_validacion = ' ';

                        this.secuencias[k].fecha_aplicacion = moment(String(this.secuencias[k].fecha_aplicacion)).format("YYYY-MM-DD");
                        if (this.secuencias[k].fecha_aplicacion == 'Invalid date') this.secuencias[k].fecha_aplicacion = ' ';

                        if (this.secuencias[k].validado == 0)
                            this.secuencias[k].error = 2;

                        let periodo = this.secuencias[k].cabecera.periodo_asociado;
                        this.secuencias[k].cabecera.periodo_clave = periodo;
                        let p = this.periodos.filter(item => {
                            return item.clave == periodo
                        });
                        if (p.length > 0) {
                            this.secuencias[k].cabecera.periodo_asociado = p[0].clave + " = " + p[0].nombre;
                        }


                    }
                    this.$root.$dialogLoader.hide();
                    this.dialog_consolidado=true;
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
      },
      parseDate(date) {
        if (!date) return null;
        return moment(String(date)).format("YYYY-MM-DD");
      },
      parseDateTime(date) {
        if (!date) return null;
        return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
      },
  
      formatNumberDec: function(numero, decimales){
              if (numero!=0 && (numero == undefined || numero == null || numero == ""))
                  return "";
              numero = Number(numero);
              if (isNaN(numero)){
                  return "";
              } else
                  return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          },
        formatNumber: function (numero, decimales) {
            if (numero == undefined || numero == null || numero == "")
                numero = 0;
            numero = Number(numero);
            if (isNaN(numero)) {
                return "";
            } else
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
      validaFecha: function(fecha) {
        if (fecha == "Invalid date")
          return "Fecha no válida."
        else
          return true;
      },
      validaAnio: function() {
        if (this.model.fecha_de != "" && this.model.fecha_a != "") {
          var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
          var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
          var diferencia = fin.diff(inicio, 'days')
          if (diferencia < 0)
            return "La Fecha Final no debe ser menor a la Fecha Inicial."
        }
        return true;
      },
      cargar_consulta() {
  
         
              this.$refs.estadoLoader.show('ESPERE UN MOMENTO POR FAVOR..');
              var data = {
                  "rfc": this.model.rfc,
                  "usuario":this.model.usuario,
                  "fecha_de":this.model.fecha_de,
                  "fecha_a":this.model.fecha_a,
              };
  
              axios({
                  method: "post",
                  url: this.$apiSA31 + "soluciona31/reportes/informes_fuera_plazo/",
                  //url: "http://127.0.0.1:7000/soluciona31/reportes/rpt_proximo_periodo/",
                  data: data
              })
              .then(response => {
                  if (response.data != undefined) {
                      this.datos = response.data;
  
                      for (var k in this.datos) {
                        
                          let periodo = this.datos[k].cabecera.periodo_asociado;
                          this.datos[k].cabecera.periodo_clave = periodo;
                          let p = this.periodos.filter(item => {
                              return item.clave == periodo
                          });
                          if (p.length > 0) {
                            this.datos[k].cabecera.periodo_asociado = p[0].clave + " = " + p[0].nombre;
                          }
  
  
                      }
  
                  } else {
                      this.datos = [];
                  }
              })
              .catch(error => {
                  this.$refs.estadoLoader.hide();
                  console.log(error);
                  this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al generar el reporte",
                  footer: "Favor de comunicarse con soporte o intente nuevamente."
                  });
              }).then(() => {
                  this.$refs.estadoLoader.hide();
              });
          
  
  
      },
      exportar: function(type, fn, dl) {
        var items = [];
        var name = "InformesFueraPlazo_" + this.model.fecha_de + "_"+ this.model.fecha_a + ".xlsx";
  
        this.datos.forEach((item) => {
                  
            items.push({
                  'Folio SAT':  item['folio'] ,
                  'Destino Aduanero' : item['cabecera']['destino_aduanero'] ,
                  'Ejercicio':  item['cabecera']['ejercicio'],
                  'Periodo Afectado':  item['cabecera']['periodo_asociado'] ,
                  'No. Movimiento':   item['cabecera']['consecutivo'] ,
                  'Fecha Recepción':   item['fecha_recepcion'].toString().substring(0,10) ,
                  'Fecha Validación':  item['fecha_validacion'].toString().substring(0,10) ,
                  'Estatus de Validación':  item['estatus_validacion'] ,
                  'Fecha Aplicación':   item['fecha_aplicacion'].toString().substring(0,10) ,
                  'Valor Comercial':   item['valor_comercial_calculado'] ,
                  'Estatus': item['estatus']
            })
          
        });
  
        const worksheet = XLSX.utils.json_to_sheet(items);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "FueraPlazo");
        XLSX.writeFile(workbook, name, { compression: true });
      }
  
    },
  };
  </script>
  <style scoped>
      .class-center {
          text-align: center !important;
      }
      .class-right {
          text-align: right !important;
      }
      .text-number {
            text-align: right;
        }
      .elevation-1 >>> .bgbien{
          background-color: #FCE4EC !important;
          font-weight: bold;
      }
      .elevation-1 >>> .bgmal {
          background-color: #FFFFDD !important;
          font-weight: bold;
      }
  </style>
  